import { useState } from 'react'
import { Monitor, X, Download } from 'lucide-react'
import { useDesktopAgent, getAgentDownloadUrl } from '../../hooks/useDesktopAgent'

const DISMISSED_KEY = 'erp_agent_banner_dismissed'

export default function AgentInstallBanner() {
  const { available } = useDesktopAgent()
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISSED_KEY) === '1')

  if (available || dismissed) return null

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem(DISMISSED_KEY, '1')
  }

  const isWindows = navigator.userAgent.includes('Windows')
  const isMac = navigator.userAgent.includes('Mac')

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4 mb-6 relative">
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Monitor className="w-6 h-6 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-900">
            MaestroAgent — Modifica i documenti con Word
          </h3>
          <p className="text-xs text-gray-600 mt-0.5">
            Installa l'agent desktop per aprire e modificare documenti ERP direttamente con Word, Excel o il tuo programma preferito.
            Le modifiche vengono caricate automaticamente.
          </p>
          <div className="flex items-center gap-2 mt-3">
            {(isWindows || (!isWindows && !isMac)) && (
              <a
                href={getAgentDownloadUrl('windows')}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors"
              >
                <Download className="w-3.5 h-3.5" />
                Scarica per Windows
              </a>
            )}
            {(isMac || (!isWindows && !isMac)) && (
              <a
                href={getAgentDownloadUrl('mac')}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 text-gray-700 text-xs font-medium rounded-lg hover:bg-gray-200 transition-colors border border-gray-200"
              >
                <Download className="w-3.5 h-3.5" />
                Scarica per Mac
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
